module.exports = __webpack_public_path__ + "fonts/Caveat-Bold.b5e9fdd3.ttf";